import React, { useState } from 'react';

function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [lightboxImage, setLightboxImage] = useState(null);

  const events = [
    { category: 'Annual Day', img: '/images/gallery/annual-day-1.jpg', title: 'Annual Day 2024', date: 'March 15, 2024' },
    { category: 'Annual Day', img: '/images/gallery/annual-day-2.jpg', title: 'Cultural Performance', date: 'March 15, 2024' },
    { category: 'Annual Day', img: '/images/gallery/annual-day-3.jpg', title: 'Prize Distribution', date: 'March 15, 2024' },
    { category: 'Sports Day', img: '/images/gallery/sports-day-1.jpg', title: 'Sports Day 2024', date: 'February 10, 2024' },
    { category: 'Sports Day', img: '/images/gallery/sports-day-2.jpg', title: 'Track Events', date: 'February 10, 2024' },
    { category: 'Sports Day', img: '/images/gallery/sports-day-3.jpg', title: 'Winners Ceremony', date: 'February 10, 2024' },
    { category: 'Science Fair', img: '/images/gallery/science-fair-1.jpg', title: 'Science Exhibition', date: 'January 20, 2024' },
    { category: 'Science Fair', img: '/images/gallery/science-fair-2.jpg', title: 'Student Projects', date: 'January 20, 2024' },
    { category: 'Science Fair', img: '/images/gallery/science-fair-3.jpg', title: 'Innovation Display', date: 'January 20, 2024' },
    { category: 'Art & Craft', img: '/images/gallery/art-craft-1.jpg', title: 'Art Competition', date: 'December 5, 2023' },
    { category: 'Art & Craft', img: '/images/gallery/art-craft-2.jpg', title: 'Creative Works', date: 'December 5, 2023' },
    { category: 'Art & Craft', img: '/images/gallery/art-craft-3.jpg', title: 'Student Artwork', date: 'December 5, 2023' },
    { category: 'Field Trip', img: '/images/gallery/field-trip-1.jpg', title: 'Museum Visit', date: 'November 18, 2023' },
    { category: 'Field Trip', img: '/images/gallery/field-trip-2.jpg', title: 'Educational Tour', date: 'November 18, 2023' },
    { category: 'Field Trip', img: '/images/gallery/field-trip-3.jpg', title: 'Group Activities', date: 'November 18, 2023' },
    { category: 'Celebrations', img: '/images/gallery/celebration-1.jpg', title: 'Independence Day', date: 'August 15, 2023' },
    { category: 'Celebrations', img: '/images/gallery/celebration-2.jpg', title: 'Republic Day', date: 'January 26, 2024' },
    { category: 'Celebrations', img: '/images/gallery/celebration-3.jpg', title: 'Teachers Day', date: 'September 5, 2023' }
  ];

  const categories = ['All', ...new Set(events.map(e => e.category))];
  const filteredEvents = selectedCategory === 'All' ? events : events.filter(e => e.category === selectedCategory);

  return (
    <section style={{background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', minHeight: '100vh', padding: '20px 0 80px 0'}}>
      <div className="container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{fontSize: '4rem', color: '#fbbf24', fontWeight: 900, marginBottom: '20px'}}>School Gallery</h2>
          <p style={{fontSize: '1.4rem', color: '#fde68a', maxWidth: '800px', margin: '0 auto'}}>Capturing memories, celebrating achievements</p>
        </div>

        <div style={{display: 'flex', justifyContent: 'center', gap: '15px', marginBottom: '50px', flexWrap: 'wrap'}}>
          {categories.map((cat, i) => (
            <button
              key={i}
              onClick={() => setSelectedCategory(cat)}
              style={{
                padding: '12px 30px',
                borderRadius: '25px',
                border: selectedCategory === cat ? '2px solid #ba68c8' : '2px solid transparent',
                background: selectedCategory === cat ? 'rgba(186, 104, 200, 0.2)' : 'rgba(255, 255, 255, 0.1)',
                color: selectedCategory === cat ? '#ba68c8' : '#fce4ec',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.background = 'rgba(186, 104, 200, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                if (selectedCategory !== cat) {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                }
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '30px'}}>
          {filteredEvents.map((event, i) => (
            <div
              key={i}
              onClick={() => setLightboxImage(event)}
              style={{
                background: 'white',
                borderRadius: '15px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0) scale(1)'}
            >
              <div style={{position: 'relative', overflow: 'hidden', height: '300px'}}>
                <img
                  src={event.img}
                  alt={event.title}
                  style={{width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s'}}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
                <div style={{position: 'absolute', top: '10px', right: '10px', background: '#ba68c8', color: 'white', padding: '5px 15px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 600}}>>
                  {event.category}
                </div>
              </div>
              <div style={{padding: '20px'}}>
                <h3 style={{fontSize: '1.2rem', color: '#1a237e', marginBottom: '8px', fontWeight: 700}}>{event.title}</h3>
                <p style={{color: '#64748b', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '5px'}}>
                  <i className="fas fa-calendar"></i> {event.date}
                </p>
              </div>
            </div>
          ))}
        </div>

        {lightboxImage && (
          <div
            onClick={() => setLightboxImage(null)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.9)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
              padding: '20px'
            }}
          >
            <div style={{position: 'relative', maxWidth: '90%', maxHeight: '90%'}}>
              <button
                onClick={() => setLightboxImage(null)}
                style={{
                  position: 'absolute',
                  top: '-40px',
                  right: '0',
                  background: '#ba68c8',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ×
              </button>
              <img
                src={lightboxImage.img}
                alt={lightboxImage.title}
                style={{maxWidth: '100%', maxHeight: '80vh', borderRadius: '10px'}}
              />
              <div style={{background: 'white', padding: '20px', borderRadius: '0 0 10px 10px', textAlign: 'center'}}>
                <h3 style={{color: '#1a237e', marginBottom: '10px'}}>{lightboxImage.title}</h3>
                <p style={{color: '#64748b'}}>{lightboxImage.category} • {lightboxImage.date}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Gallery;
